import { render, staticRenderFns } from "./VEmployerServicesBrowse.vue?vue&type=template&id=41d1293c&scoped=true&lang=pug"
import script from "./VEmployerServicesBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployerServicesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerServicesBrowse.vue?vue&type=style&index=0&id=41d1293c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d1293c",
  null
  
)

/* custom blocks */
import block0 from "./EmployerServicesBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FServices%2FServicesBrowse%2FVEmployerServicesBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports